import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) => {
    return createStyles({
        root: {
            alignItems: 'center',
            boxSizing: 'border-box',
            color: theme.palette.text.primary,
            display: 'flex',
            flex: 1,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(16),
            fontWeight: theme.typography.fontWeightMedium as number,
            minHeight: 32,
            outline: 0,
            padding: theme.spacing(0.5, 0),
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            '&:before': {
                backgroundColor: theme.palette.grey[300],
                borderRadius: '50%',
                content: '""',
                display: 'inline-block',
                flexGrow: 0,
                flexShrink: 0,
                height: 8,
                margin: '4px 12px 4px 0',
                width: 8,
            },
        },
        sizeSmall: {
            fontSize: theme.typography.pxToRem(14),
            minHeight: 24,
        },
        colorPrimary: {
            '&:before': {
                backgroundColor: theme.palette.primary.main,
            },
        },
        colorSecondary: {
            '&:before': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        colorSuccess: {
            '&:before': {
                backgroundColor: theme.palette.success.main,
            },
        },
        colorInfo: {
            '&:before': {
                backgroundColor: theme.palette.info.main,
            },
        },
        colorWarning: {
            '&:before': {
                backgroundColor: theme.palette.warning.main,
            },
        },
        colorError: {
            '&:before': {
                backgroundColor: theme.palette.error.main,
            },
        },
    });
};

export default makeStyles(styles, { name: 'MuiStatusDot' });
